import { Box, LinearProgress, Typography } from "@mui/material";
import { getColor } from "../style/color/color";
import { fonts } from "../style/fonts/fonts";

export const LinearProgressBar = ({
  progress,
  stepNumber,
  progressNumber,
  dragMessage,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          // p: 1,
          mt: "6px",
          ml: "4px",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: getColor.NeutralMIdDark400,
            fontsize: "0.8rem",
          }}
        >
          {`${stepNumber} of 4 steps completed`}
        </Typography>
        <Typography
          sx={{
            color: getColor.SecondaryIrishGreen,
          }}
        >
          {`${progressNumber}%`}
        </Typography>
      </Box>
      <Box sx={{ width: "100%" }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          color={"success"}
          sx={{
            height: 9,
            borderRadius: "24px",
            color: getColor.ExtendedpalettesIrishGreenIG100,
          }}
          style={{
            backgroundColor: getColor.ExtendedpalettesIrishGreenIG100,
            "& .MuiLinearProgress-barColorPrimary": {
              backgroundColor: getColor.ExtendedpalettesIrishGreenIG100,
            },
          }}
        />
        <Typography
          variant="body2"
          sx={{
            mt: "8px",
            fontSize: "0.9rem",
            textWrap: "stable",
            color: getColor.NeutralDark600,
            fontFamily: fonts.manrope,
            fontWeight: "400",
          }}
        >
          {dragMessage}
        </Typography>
      </Box>
    </Box>
  );
};
